import { useStarRings, useRing } from './use-starrings';
import React, { useRef } from 'react';
import { extend } from '@react-three/fiber';
import { a } from '@react-spring/three';
import * as meshline from 'threejs-meshline';
extend(meshline);
const Ring = ({ value, style }) => {
    const ring = useRef();
    useRing(ring);
    return (React.createElement(a.mesh, { "material-opacity": style === null || style === void 0 ? void 0 : style.opacity.to((x) => x * value.opacity) },
        React.createElement("meshLine", { attach: "geometry", vertices: value.vertices }),
        React.createElement("meshLineMaterial", { ref: ring, attach: "material", transparent: true, depthTest: false, sizeAttenuation: true, dashArray: value.dashArray, dashRatio: 0.2, lineWidth: value.lineWidth, color: value.color })));
};
const StarRings = (props) => {
    const { rings, startpoint } = useStarRings(props);
    return (React.createElement(a.group, { position: startpoint }, rings.map((ring, index) => {
        return React.createElement(Ring, { key: index, value: ring, style: props.style });
    })));
};
export default StarRings;
